import { createPortal } from "react-dom";
import { Lock, X } from "lucide-react";
import { BRAND_COLORS, withAlpha } from "../lib/bookingStatus";

/**
 * Feb 2026 · DSGVO / Gast-Tier · Upgrade-Sheet (5 Sep 2026 · User-Directive).
 *
 * Zeigt einen Kunden mit `status="guest"` (oder "expired") beim Klick auf
 * eine gesperrte Aktion (Buchung absenden / Extras bestellen / Sonderwunsch
 * einreichen / Angebot entscheiden) einen klar formulierten Upgrade-Hinweis.
 *
 * Die Abo-Zahlung laeuft laut Directive per Rechnung ausserhalb der App;
 * daher kein In-App-Checkout, sondern ein Kontakt-CTA (E-Mail an Team).
 */
export function GuestUpgradeDialog({ open, onClose }) {
  if (!open) return null;
  return createPortal(
    <div
      className="fixed inset-0 z-[70] flex items-center justify-center p-4"
      style={{ background: withAlpha(BRAND_COLORS.navy, 0.6) }}
      onClick={onClose}
      data-testid="guest-upgrade-dialog"
    >
      <div
        role="dialog"
        aria-modal="true"
        className="bg-white w-full max-w-md relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          onClick={onClose}
          data-testid="guest-upgrade-close"
          className="absolute top-3 right-3 text-navy-dark/50 hover:text-navy p-1"
          aria-label="Schließen"
        >
          <X className="w-4 h-4" strokeWidth={1.6} />
        </button>
        <div className="p-6 md:p-8">
          <div
            className="w-11 h-11 rounded-full flex items-center justify-center mb-4"
            style={{ background: withAlpha(BRAND_COLORS.gold, 0.15), color: BRAND_COLORS.goldDark }}
          >
            <Lock className="w-5 h-5" strokeWidth={1.6} />
          </div>
          <h2 className="font-display text-2xl text-navy leading-tight mb-2">
            Mitglieder-Funktion
          </h2>
          <p className="text-[13.5px] text-navy-dark/80 leading-relaxed mb-5">
            Diese Aktion ist Weissblom-Abonnenten vorbehalten. Als Gast können
            Sie die App vollständig ansehen, Ihr Profil pflegen und mit unserem
            Team schreiben — Buchungen, Sonderwünsche, Extras und Angebote
            werden nach dem Upgrade zum Abo freigeschaltet.
          </p>
          <p className="text-[12.5px] text-navy-dark/70 leading-relaxed mb-6">
            Die Abrechnung läuft per Rechnung, ohne In-App-Kauf.
            Schreiben Sie uns kurz, wir schalten Ihr Konto frei.
          </p>
          <div className="flex flex-wrap gap-3">
            <a
              href="mailto:info@weissblom.de?subject=Upgrade%20auf%20Abo"
              data-testid="guest-upgrade-contact-btn"
              className="inline-flex items-center gap-2 bg-navy text-ivory px-5 py-2.5 text-[12px] tracking-[0.15em] uppercase hover:bg-navy-dark transition-colors"
              style={{ background: BRAND_COLORS.navy }}
            >
              Team kontaktieren
            </a>
            <button
              type="button"
              onClick={onClose}
              data-testid="guest-upgrade-dismiss"
              className="text-[12px] tracking-[0.15em] uppercase text-navy-dark/60 hover:text-navy px-3 py-2.5"
            >
              Später
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
}
